"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardShortcutsModal = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const Key_1 = require("@jsonjoy.com/ui/lib/1-inline/Key");
const MiniTitle_1 = require("@jsonjoy.com/ui/lib/3-list-item/MiniTitle");
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
const ModalOverlay_1 = require("../ModalOverlay");
const context_2 = require("../../context");
const keys_1 = require("../../util/keys");
const data_1 = require("./data");
const Separator_1 = require("@jsonjoy.com/ui/lib/3-list-item/Separator");
const Space_1 = require("@jsonjoy.com/ui/lib/3-list-item/Space");
const wrapperClass = (0, nano_theme_1.rule)({
    bxz: 'border-box',
    w: '100%',
    maxW: '1444px',
    mr: '0 auto',
    pd: '40px 48px 56px',
});
const gridClass = (0, nano_theme_1.rule)({
    columnWidth: '280px',
    columnGap: '56px',
});
const groupClass = (0, nano_theme_1.rule)({
    d: 'flex',
    fld: 'column',
    gap: '0',
    miw: 0,
    mar: '0 0 48px',
    breakInside: 'avoid',
    WebkitColumnBreakInside: 'avoid',
    pageBreakInside: 'avoid',
});
const groupTitleClass = (0, nano_theme_1.rule)({
    mar: '0 0 10px',
});
const rowClass = (0, nano_theme_1.rule)({
    d: 'flex',
    ai: 'center',
    jc: 'space-between',
    gap: '12px',
    pd: '4px 0',
    fz: '13.5px',
    lh: '1.25',
});
const labelClass = (0, nano_theme_1.rule)({
    fls: '1 1 auto',
    miw: 0,
    ov: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});
const keysClass = (0, nano_theme_1.rule)({
    fls: '0 0 auto',
    d: 'inline-flex',
    ai: 'center',
    gap: '2px',
});
const renderKey = (raw) => {
    const mapped = keys_1.remap[raw] ?? raw;
    return mapped.length === 1 ? mapped.toUpperCase() : mapped;
};
const ShortcutKeys = ({ spec }) => {
    const styles = (0, context_1.useStyles)();
    if (spec.display)
        return (React.createElement("span", { className: keysClass },
            React.createElement(Key_1.Key, null, spec.display)));
    const keys = spec.keys ?? [];
    const plusStyle = { color: styles.g(0.5, 0.45) };
    return (React.createElement("span", { className: keysClass }, keys.map((k, i) => (React.createElement(React.Fragment, { key: i },
        i > 0 && React.createElement("span", { style: plusStyle }, "+"),
        React.createElement(Key_1.Key, null, renderKey(k)))))));
};
const ShortcutRow = ({ spec }) => {
    const styles = (0, context_1.useStyles)();
    return (React.createElement("div", { className: rowClass },
        React.createElement("span", { className: labelClass, style: { color: styles.g(0.2, 0.85) } }, spec.label),
        React.createElement(ShortcutKeys, { spec: spec })));
};
const KeyboardShortcutsModal = () => {
    const mutxt = (0, context_2.useMuTxt)();
    const open = mutxt.shortcutsOpen.use();
    const close = React.useCallback(() => mutxt.shortcutsOpen.set(false), [mutxt]);
    return (React.createElement(ModalOverlay_1.ModalOverlay, { open: open, title: "Keyboard shortcuts", onClose: close },
        React.createElement("div", { className: wrapperClass },
            React.createElement("div", { className: gridClass }, data_1.SHORTCUT_GROUPS.map((group) => (React.createElement("section", { key: group.title, className: groupClass },
                React.createElement("div", { className: groupTitleClass },
                    React.createElement(MiniTitle_1.MiniTitle, { component: "div", contrast: true }, group.title)),
                React.createElement(Separator_1.Separator, null),
                React.createElement(Space_1.Space, null),
                group.shortcuts.map((spec) => (React.createElement(ShortcutRow, { key: spec.label, spec: spec }))))))))));
};
exports.KeyboardShortcutsModal = KeyboardShortcutsModal;
